import React from 'react';
import { DataTableContext } from '@base-providers';

export function useDataTableAction() {
  return React.useContext(DataTableContext);
}
